import {Order} from 'types';
import {ReactComponent as FlagIcon} from 'assets/icons/flag.svg';
import classNames from 'classnames';
import styles from './PriorityFlag.module.scss';

interface PriorityFlagProps {
  priority?: Order['priority'] | null;
  flag_reason?: string | null;
}

export const getFlagStyle = (priority?: Order['priority'] | null) => {
  if (!priority) return;
  if (priority === 'high') {
    return styles.high;
  }
  if (priority === 'medium') {
    return styles.medium;
  }
  if (priority === 'low') {
    return styles.low;
  }
  return;
};

function PriorityFlag({priority, flag_reason}: PriorityFlagProps) {
  if (!priority) return null;

  const handleTooltipMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    const tooltip = e.currentTarget.querySelector(
      `.${styles.tooltip}`
    ) as HTMLElement;
    if (tooltip && flag_reason) {
      const rect = e.currentTarget.getBoundingClientRect();
      tooltip.style.top = `${rect.top - tooltip.offsetHeight - 8}px`;
      tooltip.style.right = `${window.innerWidth - rect.right}px`;
    }
  };
  return (
    <div
      className={styles.urgentDeliveryFlag}
      onMouseEnter={handleTooltipMouseEnter}
    >
      <FlagIcon className={classNames(styles.flag, getFlagStyle(priority))} />
      {flag_reason && <span className={styles.tooltip}>{flag_reason}</span>}
    </div>
  );
}
export default PriorityFlag;
